module.exports = __webpack_public_path__ + "static/img/5.81d819b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/5.jpg
// module id = 13So
// module chunks = 1